module.exports = __webpack_public_path__ + "146e3ae55c8af88206dc84c85a1f275b.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/demo/vertical2.png
// module id = 2407
// module chunks = 0